import { compose } from "redux";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import { ISodConflict, STATE_IDENTIFIER } from "./constants";
import emptyState from "./emptyState";

const {
  STEP_ONE,
  LOADER_IDENTIFIER,
  RESPONSE_STATE,
  SOD_CONFLICTS,
  CONFLICT_DETAILS,
  SELECTED_CONFLICT,
  CONFLICT_CREATION,
  ALL_ENTITLEMENTS,
  SELECTED_ENTITLEMENTS,
  CONFLICT_CREATION_SUMMARY,
  EXCEPTION_MANAGEMENT,
  EXCEPTION_LIST,
  EXCEPTION_CREATION,
  ALL_USERS,
  SELECTED_USERS,
  CONFLICT_TO_MODIFY,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_SOD_CONFLICTS]: (state: any, action: any) =>
    compose(immutableSet([STEP_ONE, LOADER_IDENTIFIER], true))(state),
  [actionTypes.GET_SOD_CONFLICTS_SUCCESS]: (state: any, action: any) => {
    let conflictsToReturn: ISodConflict[] = [];
    action.payload.forEach((conflict: ISodConflict) => {
      let conflictToReturn: ISodConflict = {
        sodConflictId: conflict.id,
        inputEntitlementName: conflict.inputEntitlementName,
        sodManagementInputEntitlementDescription:
          conflict.inputEntitlementDescription,
        inputApplicationName: conflict.inputApplicationName,
        sodManagementInputApplicationDescription:
          conflict.inputApplicationDescription,
        checkEntitlementName: conflict.checkEntitlementName,
        sodManagementCheckEntitlementDescription:
          conflict.checkEntitlementDescription,
        checkApplicationName: conflict.checkApplicationName,
        sodManagementCheckApplicationDescription:
          conflict.checkApplicationDescription,
        conflictCode: conflict.conflictCode,
      };
      conflictsToReturn.push(conflictToReturn);
    });
    return compose(
      immutableSet([STEP_ONE, LOADER_IDENTIFIER], false),
      immutableSet([STEP_ONE, SOD_CONFLICTS], conflictsToReturn)
    )(state);
  },
  [actionTypes.GET_SOD_CONFLICTS_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([STEP_ONE, LOADER_IDENTIFIER], false),
      immutableSet([STEP_ONE, SOD_CONFLICTS], [])
    )(state),

  [actionTypes.DELETE_SOD_CONFLICT]: (state: any, action: any) =>
    compose(immutableSet([STEP_ONE, RESPONSE_STATE], IResponseState.PENDING))(
      state
    ),
  [actionTypes.DELETE_SOD_CONFLICT_SUCCESS]: (state: any, action: any) =>
    compose(immutableSet([STEP_ONE, RESPONSE_STATE], IResponseState.SUCCESS))(
      state
    ),
  [actionTypes.DELETE_SOD_CONFLICT_FAILURE]: (state: any, action: any) =>
    compose(immutableSet([STEP_ONE, RESPONSE_STATE], IResponseState.ERROR))(
      state
    ),

  [actionTypes.SET_SELECTED_CONFLICT]: (state: any, action: any) =>
    compose(
      immutableSet([CONFLICT_DETAILS, SELECTED_CONFLICT], action.payload)
    )(state),

  [actionTypes.GET_ALL_ENTITLEMENTS]: (state: any, action: any) =>
    compose(immutableSet([CONFLICT_CREATION, LOADER_IDENTIFIER], true))(state),
  [actionTypes.GET_ALL_ENTITLEMENTS_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([CONFLICT_CREATION, LOADER_IDENTIFIER], false),
      immutableSet([CONFLICT_CREATION, ALL_ENTITLEMENTS], action.payload)
    )(state);
  },
  [actionTypes.GET_ALL_ENTITLEMENTS_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([CONFLICT_CREATION, LOADER_IDENTIFIER], false),
      immutableSet([CONFLICT_CREATION, ALL_ENTITLEMENTS], [])
    )(state),

  [actionTypes.SET_SELECTED_ENTITLEMENTS]: (state: any, action: any) =>
    compose(
      immutableSet([CONFLICT_CREATION, SELECTED_ENTITLEMENTS], action.payload)
    )(state),

  [actionTypes.CREATE_CONFLICT]: (state: any, action: any) =>
    compose(
      immutableSet(
        [CONFLICT_CREATION_SUMMARY, RESPONSE_STATE],
        IResponseState.PENDING
      )
    )(state),
  [actionTypes.CREATE_CONFLICT_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet(
        [CONFLICT_CREATION_SUMMARY, RESPONSE_STATE],
        IResponseState.SUCCESS
      )
    )(state);
  },
  [actionTypes.CREATE_CONFLICT_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet(
        [CONFLICT_CREATION_SUMMARY, RESPONSE_STATE],
        IResponseState.ERROR
      )
    )(state),

  [actionTypes.UPDATE_CONFLICT_TYPE]: (state: any, action: any) =>
    compose(
      immutableSet([CONFLICT_DETAILS, RESPONSE_STATE], IResponseState.PENDING)
    )(state),
  [actionTypes.UPDATE_CONFLICT_TYPE_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([CONFLICT_DETAILS, RESPONSE_STATE], IResponseState.SUCCESS)
    )(state);
  },
  [actionTypes.UPDATE_CONFLICT_TYPE_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([CONFLICT_DETAILS, RESPONSE_STATE], IResponseState.ERROR)
    )(state),

  [actionTypes.GET_CONFLICT_EXCEPTIONS]: (state: any, action: any) =>
    compose(immutableSet([EXCEPTION_MANAGEMENT, LOADER_IDENTIFIER], true))(
      state
    ),
  [actionTypes.GET_CONFLICT_EXCEPTIONS_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([EXCEPTION_MANAGEMENT, LOADER_IDENTIFIER], false),
      immutableSet([EXCEPTION_MANAGEMENT, EXCEPTION_LIST], action.payload)
    )(state);
  },
  [actionTypes.GET_CONFLICT_EXCEPTIONS_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([EXCEPTION_MANAGEMENT, LOADER_IDENTIFIER], false),
      immutableSet([EXCEPTION_MANAGEMENT, EXCEPTION_LIST], [])
    )(state),

  [actionTypes.EDIT_CONFLICT_EXCEPTION]: (state: any, action: any) =>
    compose(
      immutableSet(
        [EXCEPTION_MANAGEMENT, RESPONSE_STATE],
        IResponseState.PENDING
      )
    )(state),
  [actionTypes.EDIT_CONFLICT_EXCEPTION_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet(
        [EXCEPTION_MANAGEMENT, RESPONSE_STATE],
        IResponseState.SUCCESS
      )
    )(state);
  },
  [actionTypes.EDIT_CONFLICT_EXCEPTION_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([EXCEPTION_MANAGEMENT, RESPONSE_STATE], IResponseState.ERROR)
    )(state),

  [actionTypes.DELETE_CONFLICT_EXCEPTIONS]: (state: any, action: any) =>
    compose(
      immutableSet(
        [EXCEPTION_MANAGEMENT, RESPONSE_STATE],
        IResponseState.PENDING
      )
    )(state),
  [actionTypes.DELETE_CONFLICT_EXCEPTIONS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet(
        [EXCEPTION_MANAGEMENT, RESPONSE_STATE],
        IResponseState.SUCCESS
      )
    )(state);
  },
  [actionTypes.DELETE_CONFLICT_EXCEPTIONS_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([EXCEPTION_MANAGEMENT, RESPONSE_STATE], IResponseState.ERROR)
    )(state),

  [actionTypes.SET_CONFLICT_TO_MODIFY]: (state: any, action: any) =>
    compose(
      immutableSet([EXCEPTION_MANAGEMENT, CONFLICT_TO_MODIFY], action.payload)
    )(state),

  [actionTypes.GET_ALL_CREATE_EXCEPTION_USERS]: (state: any, action: any) =>
    compose(immutableSet([EXCEPTION_CREATION, LOADER_IDENTIFIER], true))(state),
  [actionTypes.GET_ALL_CREATE_EXCEPTION_USERS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([EXCEPTION_CREATION, LOADER_IDENTIFIER], false),
      immutableSet([EXCEPTION_CREATION, ALL_USERS], action.payload)
    )(state);
  },
  [actionTypes.GET_ALL_CREATE_EXCEPTION_USERS_FAILURE]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([EXCEPTION_CREATION, LOADER_IDENTIFIER], false),
      immutableSet([EXCEPTION_CREATION, ALL_USERS], [])
    )(state),

  [actionTypes.SET_CREATE_EXCEPTION_SELECTED_USERS]: (
    state: any,
    action: any
  ) =>
    compose(immutableSet([EXCEPTION_CREATION, SELECTED_USERS], action.payload))(
      state
    ),

  [actionTypes.CREATE_EXCEPTION]: (state: any, action: any) =>
    compose(
      immutableSet([EXCEPTION_CREATION, RESPONSE_STATE], IResponseState.PENDING)
    )(state),
  [actionTypes.CREATE_EXCEPTION_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([EXCEPTION_CREATION, RESPONSE_STATE], IResponseState.SUCCESS)
    )(state);
  },
  [actionTypes.CREATE_EXCEPTION_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([EXCEPTION_CREATION, RESPONSE_STATE], IResponseState.ERROR)
    )(state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
